import script from "./VReplySetSelectStats.vue?vue&type=script&lang=ts&setup=true"
export * from "./VReplySetSelectStats.vue?vue&type=script&lang=ts&setup=true"

import "./VReplySetSelectStats.vue?vue&type=style&index=0&id=0b4b9965&lang=sass"

const __exports__ = script;

export default __exports__